import { ValidatorFn, Validators } from '@angular/forms';

const PATTERN = /^[A-Za-zÀ-ÖØ-öø-ÿ \-'’]+$/;

export const personName: ValidatorFn = (control) =>
  Validators.pattern(PATTERN)(control)
    ? { personName: control.value }
    : null;
